import { asyncRoutes, constantRoutes } from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

/**
 * 根据菜单列表重构路由
 * @param asyncRoutes  路由
 * @param menus        菜单
 */
export function generateAsyncRoutes(routes,menus) {
  let arr=[]
  /*routes.forEach(router=>{
    let item ={...router}
    menus.forEach(menu=>{
      let menuUrl = menu.attributes.vueUrl||'',path= router.path||'';
      if(menuUrl.indexOf(path)!== -1){
        item.meta.icon = menu.attributes.vueIcon||item.meta.icon||'';
        item.meta.title = menu.text||'';
        if(menu.children && menu.children.length>0){
          item.children=generateAsyncRoutes(item.children,menu.children)
        }
        arr.push(item)
      }
    })
    if(router.path === "*"){
      arr.push(item)
    }
  })*/
  menus.forEach(menu=>{
    let menuUrl = menu.attributes.vueUrl||'';
    routes.forEach(router=>{
      let path= router.path||'';
      if(menuUrl.indexOf(path)!== -1){
        let item ={...router}
        item.meta.icon = menu.attributes.vueIcon||item.meta.icon||'';
        item.meta.title = menu.text||'';
        if(menu.children && menu.children.length>0){
          item.children=generateAsyncRoutes(item.children,menu.children)
        }
        arr.push(item)
      }
    })
  })
  return arr
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes
      if (roles.includes('admin')) {
        accessedRoutes = asyncRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  getAuthRoutes({ commit }, menus) {
    return new Promise(resolve => {
      let accessedRoutes= generateAsyncRoutes(asyncRoutes,menus)
      asyncRoutes.forEach(router=>{
        if(router.path === "*"){
          accessedRoutes.push(router)
        }
      })
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
